import React from "react";
import "./trafficLightIndicator.css";

const TrafficLightIndicatorActivity = ({ category, riskLevel, recommendation }) => {
  let textRisk = ""
  // Asignar color según el nivel de riesgo
  const getColor = (level) => {
    switch (level) {
      case 0:
        textRisk = "Estilo de vida muy activa"
        return "green";
      case 1:
        textRisk = "Estilo de vida activa"
        return "green";
      case 2:
        textRisk = "Estilo de vida poco activa"
        return "yellow";
      case 3:
        textRisk = "Estilo de vida Sedentario"
        return "red";
      default:
        return "gray";
    }
  };

  return (
    <div className="traffic-light-indicator">
      <h3 className="category-title">&nbsp;</h3>
      <div className={`traffic-light ${getColor(riskLevel)}`}>
        {textRisk}
      </div>
      <p className="recommendation">{recommendation}</p>
    </div>
  );
};

export default TrafficLightIndicatorActivity;
